import axios from '@/utils/request'

/***************************管线管理*************************** */
// 分页查询 - 张羽
export function Linespagelist(params) {
  const Linespagelist = axios({
    url: '/patrolLines/page',
    method: 'get',
    params
  })
  return Linespagelist
}
// 获取管线数量和长度- 张羽
export function getLinesNumAndLength(params) {
  const getLinesNumAndLength = axios({
    url: '/patrolLines/getLinesNumAndLength',
    method: 'get',
    params
  })
  return getLinesNumAndLength
}
// 查询单条- 张羽
export function LinesfindById(params) {
  const LinesfindById = axios({
    url: '/patrolLines/findById',
    method: 'get',
    params
  })
  return LinesfindById
}
// 新增 管线- 张羽
export function saveLine(data) {
  const saveLine = axios({
    url: '/patrolLines/save',
    method: 'post',
    data
  })
  return saveLine
}
// 修改 管线- 张羽
export function updateLine(data) {
  const updateLine = axios({
    url: '/patrolLines/update',
    method: 'post',
    data
  })
  return updateLine
}
// 删除- 张羽
export function LinesDelete(params) {
  const LinesDelete = axios({
    url: '/patrolLines/delete',
    method: 'get',
    params
  })
  return LinesDelete
}
/*********************************图层********************************* */
// 图层树- 张羽
export function GisLayerfindTree(params) {
  const GisLayerfindTree = axios({
    url: '/patrolGisLayer/findTree',
    method: 'get',
    params
  })
  return GisLayerfindTree
}
// 新增 图层- 张羽
export function coverageAdd(data) {
  const coverageAdd = axios({
    url: '/patrolGisLayer/save',
    method: 'post',
    data
  })
  return coverageAdd
}
// 删除- 张羽
export function coverageDelete(params) {
  const GisLayerfindTree = axios({
    url: '/patrolGisLayer/delete',
    method: 'get',
    params
  })
  return GisLayerfindTree
}
// 上移下移- 张羽
export function coverageSort(data) {
  const coverageSort = axios({
    url: '/patrolGisLayer/changeSort',
    method: 'post',
    data
  })
  return coverageSort
}
// 巡线员列表- 张羽
export function coverageExecutor(params) {
  const coverageExecutor = axios({
    url: '/patrolGisLayer/findExecutors',
    method: 'get',
    params
  })
  return coverageExecutor
}
/********************************事件************************************** */
// 分页查询- 张羽
export function Eventspage(params) {
  const Eventspage = axios({
    url: '/patrolEvents/page',
    method: 'get',
    params
  })
  return Eventspage
}
// 查看详情- 张羽
export function EventsfindById(params) {
  const EventsfindById = axios({
    url: '/patrolEvents/findById',
    method: 'get',
    params
  })
  return EventsfindById
}
/**********************************设备***************************************** */
// 分页查询- 张羽
export function Equipmentspage(params) {
  const Eventspage = axios({
    url: '/patrolEquipments/page',
    method: 'get',
    params
  })
  return Eventspage
}

// 新增- 张羽
export function saveEquipment(data) {
  const saveEquipment = axios({
    url: '/patrolEquipments/save',
    method: 'post',
    data
  })
  return saveEquipment
}
// 修改- 张羽
export function updateEquipment(data) {
  const updateEquipment = axios({
    url: '/patrolEquipments/update',
    method: 'post',
    data
  })
  return updateEquipment
}
// 删除- 张羽
export function EquipmentsDelete(params) {
  const EquipmentsDelete = axios({
    url: '/patrolEquipments/delete',
    method: 'get',
    params
  })
  return EquipmentsDelete
}
// 查询单条- 张羽
export function EquipmentsfindById(params) {
  const EquipmentsfindById = axios({
    url: '/patrolEquipments/findById',
    method: 'get',
    params
  })
  return EquipmentsfindById
}
// 设置、取消巡检点- 张羽
export function EquipmentscheckingPoint(params) {
  const EquipmentscheckingPoint = axios({
    url: '/patrolEquipments/checkingPoint',
    method: 'get',
    params
  })
  return EquipmentscheckingPoint
}
/******************************巡检区域**************************************** */
// 删除- 张羽
export function NetworksDelete(params) {
  const NetworksDelete = axios({
    url: '/patrolNetworks/delete',
    method: 'get',
    params
  })
  return NetworksDelete
}
// 查询单条- 张羽
export function NetworksfindById(params) {
  const NetworksfindById = axios({
    url: '/patrolNetworks/findById',
    method: 'get',
    params
  })
  return NetworksfindById
}
// 分页查询- 张羽
export function Networkspage(params) {
  const Networkspage = axios({
    url: '/patrolNetworks/page',
    method: 'get',
    params
  })
  return Networkspage
}
// 片区切换显示- 张羽
export function Networkswitche(params) {
  const Networkswitche = axios({
    url: '/patrolNetworks/switchover',
    method: 'get',
    params
  })
  return Networkswitche
}
// 新增- 张羽
export function saveNetworks(data) {
  const saveNetworks = axios({
    url: '/patrolNetworks/save',
    method: 'post',
    data
  })
  return saveNetworks
}
// 修改- 张羽
export function updateNetworks(data) {
  const updateNetworks = axios({
    url: '/patrolNetworks/update',
    method: 'post',
    data
  })
  return updateNetworks
}
// 片区查看打卡点- 张羽
export function showClockPoints(params) {
  const showClockPoints = axios({
    url: '/patrolNetworks/showClockPoints',
    method: 'get',
    params
  })
  return showClockPoints
}
// 按照条件查片区下拉- 张羽
export function getNetWorkList(params) {
  const getNetWorkList = axios({
    url: '/patrolNetworks/getNetWork',
    method: 'get',
    params
  })
  return getNetWorkList
}
// 片区查询设备及管线类型- 张羽
export function getEqTypeAndLinesType(params) {
  const getEqTypeAndLinesType = axios({
    url: '/patrolNetworks/getEqTypeAndLinesType',
    method: 'get',
    params
  })
  return getEqTypeAndLinesType
}
/**************************打卡点******************************** */
// 新增- 张羽
export function savepatrol(data) {
  const savepatrol = axios({
    url: '/patrolClock/save',
    method: 'post',
    data
  })
  return savepatrol
}
// 删除- 张羽
export function deletepatrol(params) {
  const deletepatrol = axios({
    url: '/patrolClock/delete',
    method: 'get',
    params
  })
  return deletepatrol
}
// 修改- 张羽
export function updatepatrol(data) {
  const updatepatrol = axios({
    url: '/patrolClock/update',
    method: 'post',
    data
  })
  return updatepatrol
}
// 详情- 张羽
export function ClockfindById(params) {
  const ClockfindById = axios({
    url: '/patrolClock/findById',
    method: 'get',
    params
  })
  return ClockfindById
}
/************************************************************* */
//工具箱-标记新增或更新
export function saveMake(params) {
  return axios({
    url: '/layerTools/mark/update',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}
//工具箱-标记查询
export function makeList(params) {
  return axios({
    url: '/layerTools/mark/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}
//工具箱-删除
export function delMake(params) {
  return axios({
    url: '/layerTools/mark/delete',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}
// 获取中心店
export function getMapCenterLocation(params) {
  return axios({
    url: '/sysCity/getLocation',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}
/*************************************人员****************************************** */
//人员轨迹
export function userPath(params) {
  return axios({
    url: '/patrolGisLayer/findExecutorTrack',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}
// 查询单条人员- 张羽
export function findExecutorsInfo(params) {
  const findExecutorsInfo = axios({
    url: '/patrolGisLayer/findExecutorsInfo',
    method: 'get',
    params
  })
  return findExecutorsInfo
}
